import React from 'react';
import queryString from 'query-string';
import { useDispatch, useSelector } from 'react-redux';

import CleaningButtons from './CleaningButtons.js';
import { config } from '../config';
import { showSnackbar, setResponse } from '../state/actions-creators/index.js';
import { useAuth } from '../hooks/useAuth';

const CleaningInfo = () => {
  const params = new URL(document.location).searchParams;
  const pathIds = window.location.pathname.split('/');
  const orgId = params.get('organization') || pathIds[1];
  const locationId = params.get('location') || pathIds[2];
  const dispatch = useDispatch();
  const { area } = useSelector((state) => state);
  const { token } = useAuth();

  const callResetApi = async (eventType) => {
    /* Calls LnT API/v1/reset
            - Sends data to database via Hasura API
            - Reset assets cleaned via EB API
        */
    const parsed = queryString.parse(window.location.search);

    let sessionId = await fetch(`${config.lnt_api_url}/session`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        area: eventType === 'start' ? '%%' : area,
        orgId: orgId,
        locationId: locationId,
        token: token,
      }),
    })
      .then((res) => res.json())
      .then((json) => {
        if (eventType === 'start') return json + 1;
        else return json;
      })
      .catch((err) => {
        console.log('Error in App.js, calling /v1/session');
        console.log(err);
      });

    fetch(`${config.lnt_api_url}/reset?id=${parsed.id}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        ts: new Date().toJSON().slice(0, -5),
        type: eventType,
        session_id: sessionId,
        orgId: orgId,
        locationId: locationId,
        area: area,
        token: token,
      }),
    })
      .then((response) => {
        dispatch(showSnackbar());
        dispatch(setResponse(response.status));
      })
      .catch((err) => {
        console.log('Error in Apollo.js, calling /v1/reset');
        console.log(err);
      });
  };

  return (
    <>
      <CleaningButtons callResetApi={callResetApi} />
    </>
  );
};

export default CleaningInfo;
